import React from 'react'
// CSS
import '../assets/css/project-card.css'

export default function ProjectCard(props) {
  return (
    <div className='project_card'>
      <div className='banner'>
        <img src={props.banner} alt='banner' />
      </div>

      <div className='details'>
        <span>{props.type}</span>
        <h3>{props.title}</h3>
        <a href={props.link} className='select_n' target='_blank' rel='noopener noreferrer'>View Project <i className="fa-solid fa-circle-arrow-right"></i></a>
      </div>
    </div>
  )
}
